const INSURER_RATES_STORAGE_KEY = 'quoting-insurer-rates';

// Insurer rates are shared, read-only reference data (not specific to a user or
// quotation), so both pages read/write the same cache - the same reasoning as
// caching the app config in localStorage.
export function loadCachedInsurerRates() {
  try {
    const stored = localStorage.getItem(INSURER_RATES_STORAGE_KEY);

    if (!stored) return [];

    const parsed = JSON.parse(stored);

    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error('Failed to read cached insurer rates from localStorage:', error);
    return [];
  }
}

export function saveCachedInsurerRates(insurerRates) {
  try {
    localStorage.setItem(INSURER_RATES_STORAGE_KEY, JSON.stringify(insurerRates || []));
  } catch (error) {
    console.error('Failed to cache insurer rates to localStorage:', error);
  }
}
